import { FlightData, TrackerProps } from '../types'
import { parseFlight } from './parser'
import { getAirportData } from '../utils'

export async function getFlight (props: TrackerProps): Promise<FlightData[]> {
  try {
    const response = await fetch(`https://xml.flightview.com/fvFlightTrackerLive/fvxml.exe?acid=${props.flightNo || ''}&al=${props.airline || ''}&depdate=${props.departureDate || ''}&depap=${props.departureAirport || ''}&arrap=${props.arrivalAirport || ''}`)
    const text = await response.text()
    return await parseXml(text)
  } catch (err) {
    return null
  }
}

async function parseXml (rawXml: string): Promise<FlightData[]> {
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(rawXml, 'text/xml')
  const flights = parseFlight(xmlDoc)
  if (flights) {
    await enrichResponse(flights)
  }
  return flights
}

async function enrichResponse (flights: FlightData[]) {
  for (const flight of flights) {
    flight.departureAirport.coords = await getAirportData(flight.departureAirport.code)
    flight.arrivalAirport.coords = await getAirportData(flight.arrivalAirport.code)
  }
}
